import React from 'react'
import { Link } from 'react-static'

import { trackedClick, countProviderModels } from 'utils'
import { LegacyMark } from './LegacyMark'

import SvgIcon from './SvgIcon'

const ProviderAsAPICard = ({ provider, noModels }) => {
    const { id, api_id, vendor, description, picture, showBolt } = provider

    return (
        <div className="api-cards__item">
            <div className="api-card">
                {showBolt && (
                    <div className="api-card__badge" title="Integrated API">
                        <SvgIcon slug="bolt" />
                    </div>
                )}
                <Link
                    className="api-card__link"
                    to={`/api-platform/api/${api_id}`}
                    href={`/api-platform/api/${api_id}`}
                    title={vendor}
                    onClick={trackedClick('API card provider clicked', {
                        source: 'Provider page',
                        title: api_id,
                    })}
                >
                    <div className="api-card__image">
                        <img
                            style={{ maxHeight: 120, maxWidth: 148 }}
                            src={`/${picture}`}
                            alt="Logo"
                        />
                    </div>
                    <div className="api-card__content">
                        <h5 className="api-card__title">{vendor} <LegacyMark providerId={id} /></h5>
                        <p className="api-card__text" title={description}>
                            {description}
                        </p>
                        <div className="api-card__subtext">
                            {noModels ? '' : countProviderModels(provider)}
                        </div>
                    </div>
                </Link>
            </div>
        </div>
    )
}

export default ProviderAsAPICard



// WEBPACK FOOTER //
// /usr/src/app/frontend/src/components/ProviderAsAPICard.jsx